import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import HomeIcon from '@material-ui/icons/Home';

export const homeRouteRef = createRouteRef();

// Mounted at /home. app-config.yaml moves it to / so it is the page you land
// on after sign-in, and keeps All Hubs & Spokes at /spoke-overview.
const homePage = PageBlueprint.make({
  params: {
    path: '/home',
    title: 'Home',
    icon: <HomeIcon fontSize="inherit" />,
    routeRef: homeRouteRef,
    loader: async () => {
      const { HomePage } = await import('./HomePage');
      return <HomePage />;
    },
  },
});

export const homePlugin = createFrontendPlugin({
  pluginId: 'datasphere-home',
  extensions: [homePage],
});
